import AdminClient from '../client/AdminClient';
import {transformIDsToHash} from "../../../helpers/utils";

class NewsService {
    static async delete(newsId, session) {
        return AdminClient.delete(`/v1/admin/news/${newsId}`, session);
    }


    static async create(session, params) {
        return AdminClient.post(`/v1/admin/news/`, session, this.parsedNew(params));
    }

    static async update(pieceOfNewsId, session, params) {
        return AdminClient.put(`/v1/admin/news/${pieceOfNewsId}`, session, this.parsedNew(params));
    }

    static async edit(pieceOfNewsId, session) {
        return AdminClient.get(`/v1/admin/news/${pieceOfNewsId}/edit`, session);
    }

    static async publishers(session, params={}) {
        return AdminClient.get(`/v1/admin/news/publishers`, session, params);
    }

    static async foundationEntities(session, params) {
        return AdminClient.get(`/v1/admin/news/ef_entities`, session, params);
    }

    static async foundationContacts(session, params) {
        return AdminClient.get(`/v1/admin/news/ef_contacts`, session, params);
    }

    static async btEntities(session, params) {
        return AdminClient.get(`/v1/admin/news/bt_entities`, session, params);
    }

    static async btContacts(session, params) {
        return AdminClient.get(`/v1/admin/news/bt_contacts`, session, params);
    }

    static parsedNew(pieceOfNews) {
        const associatedItemsHash = this.transformAssociatedItems(pieceOfNews.associated_items);

        return {
            piece_of_news: {
                ...pieceOfNews,
                associated_items: associatedItemsHash,
                item_contact_ids: transformIDsToHash(pieceOfNews.item_contact_ids),
                firm_ids: transformIDsToHash(pieceOfNews.firm_ids),
            }
        };
    }

    static transformAssociatedItems(associatedItems) {
        const associatedItemsHash = {};

        for (const key in associatedItems) {
            if (Array.isArray(associatedItems[key])) {
                const itemsArray = associatedItems[key].map(item => {
                    return { "id": item.id, "name": item.name, "type": item.type };
                });
                associatedItemsHash[key] = {};
                itemsArray.forEach((item, index) => {
                    associatedItemsHash[key][index] = item;
                });
            }
        }

        return associatedItemsHash;
    }
}
export default NewsService;